import { get_color } from "../../../report-visuals/report-utils";
import { parseOptionalColorHex, type TARSBarChartPoint } from "./tarsBarChartHelpers";

export const TARS_CHART_FILL_FALLBACK_HEX = "#6366f1";

/** Resolved bar/column/slice fill from point config or palette index. */
export function resolveTarsPointFillHex(
  point: TARSBarChartPoint | undefined,
  dataItemIndex: number
): string {
  const fromPoint = parseOptionalColorHex(point?.fillHex);
  if (fromPoint) return fromPoint;
  if (dataItemIndex >= 0) return get_color(dataItemIndex);
  return TARS_CHART_FILL_FALLBACK_HEX;
}

/** Per-column fill from `dataContext.fillHex` (reliable vs `columns.indexOf`). */
export function bindBarColumnFillAdapter(amChartsCore: any, columnSeries: any): void {
  columnSeries.columns.template.adapters.add("fill", (_fill: unknown, columnSprite: any) => {
    const ctx = columnSprite.dataItem?.dataContext as TARSBarChartPoint | undefined;
    const idx =
      columnSprite.dataItem != null
        ? columnSeries.dataItems.indexOf(columnSprite.dataItem)
        : -1;
    return amChartsCore.color(resolveTarsPointFillHex(ctx, idx));
  });
}
